import React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {TableCell} from "@mui/material";
import TableBody from "@mui/material/TableBody";

export const WinsPoolResultsGrid = ({scoreboard, results, loading}) => {
    if (scoreboard.length === 0 || results.length === 0) return <div/>

    const colWidth = 150;

    const renderPickCell = (params) => {
        const [winLose, team, resultsStr] = `${params.row[params.field]}`.split('|')
        const results = resultsStr.split('.');
        const gameTableCells = [];
        for (let c = 0; c < results.length; c++) {
            const result = results[c];
            const color = (result === 'O' || result === 'X') ? '' : result === winLose ? 'lightgreen' : 'lightcoral';
            gameTableCells.push(
                <TableCell key={`${team}${winLose}${c}`} style={{padding: 0, textAlign: "center", backgroundColor: color}}>{result}</TableCell>
            );
        }
        return (
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={5} style={{textAlign: "center"}}>
                                <span>{team}</span>
                                <span> - </span>
                                <span style={winLose === 'W' ? {color: "green"} : {color: "red"}}>{winLose}</span>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {gameTableCells.slice(0, 5)}
                        </TableRow>
                        <TableRow>
                            {gameTableCells.slice(5, 10)}
                        </TableRow>
                        <TableRow>
                            {gameTableCells.slice(10, 15)}
                        </TableRow>
                        <TableRow>
                            {gameTableCells.slice(15, results.length + 1)}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    const buildColumns = () => {
        const common = {sortable: false, disableColumnMenu: true, headerClassName: 'grid-header'};
        const cols = [
            {...common, width: 60, headerName: ' ', field: 'id'}
        ];
        for (const managerName of scoreboard.managerNames) {
            cols.push({
                ...common,
                width: colWidth,
                headerName: managerName,
                field: managerName,
                headerAlign: 'center',
                align: 'center',
                renderCell: renderPickCell
            });
        }
        return cols;
    };

    const buildRowData = () => {
        const rows = [];
        const cellsInCols = {};
        for (const [managerName, picks] of Object.entries(scoreboard.picks)) {
            if (!cellsInCols[managerName]) cellsInCols[managerName] = [];
            for (const [, pickDef] of Object.entries(picks)) {
                const gameResultsString = buildResultsString(scoreboard.scores[managerName][pickDef.team]);
                const cell = `${pickDef.to_win ? 'W' : 'L'}|${pickDef.team}|${gameResultsString}`;
                cellsInCols[managerName].push(cell);
            }
        }
        const rowCount = 4; //TODO: picks.length / (cols.length - 1);
        for (let rowNum = 1; rowNum <= rowCount; rowNum++) {
            const row = {id: rowNum};
            rows.push(row);
        }
        for (const col of columns) {
            const managerColumnCells = cellsInCols[col.field];
            if (managerColumnCells) {
                managerColumnCells.forEach((cell, i) => {
                    rows[i][col.field] = cell;
                });
            }
        }
        return rows;
    };

    const buildResultsString = (resultsMap) => {
        const resultsChars = [];
        const weekNumsPlayed = Object.keys(resultsMap).map(n => parseInt(n));
        const lastWeekNumPlayed = Math.max(...weekNumsPlayed);
        for (let w = 1; w <= lastWeekNumPlayed; w++) {
            if (!weekNumsPlayed.includes(w)) {
                resultsChars.push('X');
            } else {
                resultsChars.push(resultsMap[`${w}`].game_result === null ? 'O' : resultsMap[`${w}`].game_result);
            }
        }
        return resultsChars.join('.')
    };

    const columns = buildColumns();
    const rows = buildRowData();
    return (
        <div style={{width: 71 + (8 * colWidth)}}>
            {loading && <LinearProgress color="secondary"/>}
            {columns.length > 0 && rows.length > 0 && results.length > 0 &&
                <DataGrid columns={columns} rows={rows} columnHeaderHeight={30} rowHeight={150} autoHeight
                          disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize
                          slots={{footer: WinsPoolResultsGridFooter}}
                          slotProps={{footer: {cols: columns, colWidth: colWidth, results: results}}}
                />
            }
        </div>
    );
};

const WinsPoolResultsGridFooter = ({cols, colWidth, results}) => {
    const cellStyle = {width: colWidth, textAlign: "center"};
    const correctCountCells = [];
    const rankingCells = [];
    for (let c = 1; c < cols.length; c++) {
        correctCountCells.push(
            <td key={`T${c}`}
                style={cellStyle}>{results.filter(r => r.manager_name === cols[c].field)[0].total_score}</td>
        );
        rankingCells.push(
            <td key={`R${c}`} style={cellStyle}>{results.filter(r => r.manager_name === cols[c].field)[0].rank}</td>
        );
    }
    return (
        <div style={{marginTop: 20}}>
            <table>
                <tbody>
                <tr>
                    <td key="Total" style={{width: 40, paddingLeft: 10, textAlign: "left"}}>Total</td>
                    {correctCountCells}
                </tr>
                <tr>
                    <td key="Rank" style={{width: 40, paddingLeft: 10, textAlign: "left"}}>Rank</td>
                    {rankingCells}
                </tr>
                </tbody>
            </table>
        </div>
    );
};
